// src/features/clinical/services/clinicalApi.js
import httpClient from '../../../shared/services/httpClient';
import {
  mockPatients,
  mockVisits,
  mockPrescriptions,
  mockDoctors,
  mockMedicines,
  mockTests
} from './clinicalMockData';

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

class ClinicalApiService {
  constructor() {
    this.patients = [...mockPatients];
    this.visits = [...mockVisits];
    this.prescriptions = [...mockPrescriptions];
    this.doctors = [...mockDoctors];
    this.medicines = [...mockMedicines];
    this.tests = [...mockTests];
  }

  // Patient Management
  async getPatients() {
    await delay(500);
    return { data: this.patients };
  }

  async getPatient(id) {
    await delay(300);
    const patient = this.patients.find(p => p.id === id);
    return { data: patient };
  }

  // async searchPatients(query) {
  //   await delay(300);
  //   const results = this.patients.filter(p => 
  //     p.name.toLowerCase().includes(query.toLowerCase()) ||
  //     p.patientId.toLowerCase().includes(query.toLowerCase()) ||
  //     p.contact.includes(query)
  //   );
  //   return { data: results };
  // }

  
  async searchPatients(query, page = 1, perPage = 10) {
  const response = await httpClient.get('/patients', {
    params: {
      page: page,
      per_page: perPage,
      search: query
    }
  });

  return { data: response.data.data };
}
  

  async createPatient(patientData) {
    await delay(500);
    const newPatient = {
      ...patientData,
      id: `P${Date.now()}`,
      patientId: `PT-${Date.now().toString().slice(-4)}`,
      registrationDate: new Date().toISOString(),
      status: 'ACTIVE'
    };
    this.patients.push(newPatient);
    return { data: newPatient };
  }

  async updatePatient(id, patientData) {
    await delay(500);
    const index = this.patients.findIndex(p => p.id === id);
    if (index !== -1) {
      this.patients[index] = { ...this.patients[index], ...patientData };
      return { data: this.patients[index] };
    }
    throw new Error('Patient not found');
  }

  // Visit Management

  async getVisits(query, page = 1, perPage = 10) {
  const response = await httpClient.get('/visits', {
    params: {
      page: page,
      per_page: perPage,
      search: query
    }
  });

  return { data: response.data.data };
}
  // async getVisits(patientId = null) {
  //   await delay(500);
  //   if (patientId) {
  //     const visits = this.visits.filter(v => v.patientId === patientId);
  //     return { data: visits };
  //   }
  //   return { data: this.visits };
  // }

  async getVisit(id) {
    await delay(300);
    const visit = this.visits.find(v => v.id === id);
    return { data: visit };
  }

  async createVisit(visitData) {
    await delay(500);
    const patient = this.patients.find(p => p.id === visitData.patientId);
    const newVisit = {
      ...visitData,
      id: `V${Date.now()}`,
      visitId: `VIS-${new Date().getFullYear()}-${String(this.visits.length + 1).padStart(3, '0')}`,
      visitDate: new Date().toISOString(),
      patientName: patient?.name,
      status: 'IN_PROGRESS'
    };
    this.visits.push(newVisit);
    return { data: newVisit };
  }

  async updateVisit(id, visitData) {
    await delay(500);
    const index = this.visits.findIndex(v => v.id === id);
    if (index !== -1) {
      this.visits[index] = { ...this.visits[index], ...visitData };
      return { data: this.visits[index] };
    }
    throw new Error('Visit not found');
  }

  async updateVitals(visitId, vitalsData) {
    await delay(300);
    const visit = this.visits.find(v => v.id === visitId);
    if (visit) {
      visit.vitals = { ...visit.vitals, ...vitalsData };
      
      // Calculate BMI if height and weight are provided
      if (vitalsData.height && vitalsData.weight) {
        const heightInM = vitalsData.height / 100;
        visit.vitals.bmi = (vitalsData.weight / (heightInM * heightInM)).toFixed(1);
      }
      
      return { data: visit.vitals };
    }
    throw new Error('Visit not found');
  }

  // Prescription Management
  async getPrescriptions(patientId = null, visitId = null) {
    await delay(500);
    let prescriptions = this.prescriptions;
    if (patientId) {
      prescriptions = prescriptions.filter(p => p.patientId === patientId);
    }
    if (visitId) {
      prescriptions = prescriptions.filter(p => p.visitId === visitId);
    }
    return { data: prescriptions };
  }

  async createPrescription(prescriptionData) {
var newPrescriptionData=
    {
  "visit_id": prescriptionData.visitId,
  "medicines": prescriptionData.medicines,
  "employee_id": 12,
  "prescribed_by": 3,
  "dosage": "10 mg",
  "frequency": "Once daily",
  "duration": "7 days",
  "route": "oral",
  "quantity": 7,
  "refills": 0,
  "instructions": "Take at night",
  "is_controlled_substance": true,
  "controlled_substance_lot_number": "LOT12345",
  "prescriber_dea_number": "DEA998877"
}
    try {
      const response = await httpClient.post(
        '/prescriptions',
        prescriptionData
    );

    return response.data;

  } catch (error) {
    console.error('Prescription creation failed', error);
    throw error;
  }


    // Update visit status if needed
    // if (visit) {
    //   visit.status = 'COMPLETED';
    //   if (prescriptionData.followUpDate) {
    //     visit.followUpDate = prescriptionData.followUpDate;
    //   }
    // }
    return {};
  }

  
  async searchPatients(query, page = 1, perPage = 10) {
    const response = await httpClient.get('/patients', {
      params: {
        page: page,
        per_page: perPage,
        search: query
      }
    });

    return { data: response.data.data };
  }

  // Lookup Data
  async getDoctors() {
    await delay(300);
    return { data: this.doctors };
  }

  // async getMedicines() {
  //   await delay(300);
  //   return { data: this.medicines };
  // }

  async getMedicines(query, page = 1, perPage = 10) {
  const response = await httpClient.get('/stock/medicines', {
    params: {
      page: page,
      per_page: perPage,
      search: query
    }
  });

  return { data: response.data.data };
}

  async getTests() {
    await delay(300);
    return { data: this.tests };
  }

  async getDoctorById(id) {
    await delay(200);
    const doctor = this.doctors.find(d => d.id === id);
    return { data: doctor };
  }
}

export default new ClinicalApiService();